<template>
    <div class="espacio">
        <b-container fluid>
            <b-row>
                <b-col class="col-color" lg="6">
                    <h4>Nuestro propósito</h4>
                    <h2>“Elevar el alma de la mujer mexicana a sentirse libre, única, guapa y segura”</h2>
                </b-col>
                <b-col class="col-img" lg="6">
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.espacio{
    margin-bottom: 130px; 
}
.col-color{
    background: #EEBBAE;
    padding: 10% 5%;
    color: #fff;
}
.col-img{
    background: url('../assets/img/imgproposito.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
h4{
    font-size: 30px;
    margin-bottom: 25px;
}
h2{
    font-size: 40px;
    margin-bottom: 25px;
}
p{
    font-size: 20px;
}
</style>